const gameRoutes = [
    {
        path:'index',
        name:'game-index',
        component: () => import(/* webpackChunkName: "about" */ '@/views/games/index.vue')
    },
    {
        path:'multiple/:game',
        name:'game-multiple',
        component: () => import(/* webpackChunkName: "about" */ '@/views/games/multipleGame.vue')
    },
    {
        path:'logic',
        name:'game-logic',
        component: () => import(/* webpackChunkName: "about" */ '@/views/games/logic.vue')
    },
    {
        path:'focus',
        name:'game-focus',
        component: () => import(/* webpackChunkName: "about" */ '@/views/games/focus.vue')
    },
    {
        path:'memory',
        name:'game-memory',
        component: () => import(/* webpackChunkName: "about" */ '@/views/games/memory.vue')
    },
    {
        path:'reaction',
        name:'game-reaction',
        component: () => import(/* webpackChunkName: "about" */ '@/views/games/reaction.vue')
    },
    {
        path:'color',
        name:'game-color',
        component: () => import(/* webpackChunkName: "about" */ '@/views/games/color.vue')
    },
    {
        path:'poker',
        name:'game-poker',
        component: () => import(/* webpackChunkName: "about" */ '@/views/games/poker.vue')
    },
    {
        path:'kind',
        name:'game-kind',
        component: () => import(/* webpackChunkName: "about" */ '@/views/games/kind.vue')
    },
    {
        path:'operations',
        name:'game-operations',
        component: () => import(/* webpackChunkName: "about" */ '@/views/games/operations.vue')
    },
    {
        path:'gophers',
        name:'game-gophers',
        component: () => import(/* webpackChunkName: "about" */ '@/views/games/gophers.vue')
    },
    {
        path:'coin',
        name:'game-coin',
        component: () => import(/* webpackChunkName: "about" */ '@/views/games/coin.vue')
    },
    {
        path:'only',
        name:'game-only',
        component: () => import(/* webpackChunkName: "about" */ '@/views/games/only.vue')
    },
    {
        path:'pokercard',
        name:'game-pokercard',
        component: () => import(/* webpackChunkName: "about" */ '@/views/games/pokercard.vue')
    },
    {
        path:'treasure',
        name:'game-treasure',
        component: () => import(/* webpackChunkName: "about" */ '@/views/games/treasure.vue')
    },
    {
        path:'mahjong',
        name:'game-mahjong',
        component: () => import(/* webpackChunkName: "about" */ '@/views/games/mahjong.vue')
    },
    {
        path:'shut',
        name:'game-shut',
        component: () => import(/* webpackChunkName: "about" */ '@/views/games/shut.vue')
    },
    {
        path:'medicine',
        name:'game-medicine',
        component: () => import(/* webpackChunkName: "about" */ '@/views/games/medicine.vue')
    },
    {
        path:'faster',
        name:'game-faster',
        component: () => import(/* webpackChunkName: "about" */ '@/views/games/faster.vue')
    },
    {
        path:'elements',
        name:'game-elements',
        component: () => import(/* webpackChunkName: "about" */ '@/views/games/elements.vue')
    },
    {
        path:'gameEnd',
        name:'game-end',
        component: () => import(/* webpackChunkName: "about" */ '@/views/games/gameEndView.vue')
    },
  ]
  export default gameRoutes